import { render, staticRenderFns } from "./ValidationResourceModal.vue?vue&type=template&id=3265ac3e&scoped=true&"
import script from "./ValidationResourceModal.vue?vue&type=script&lang=ts&"
export * from "./ValidationResourceModal.vue?vue&type=script&lang=ts&"
import style1 from "./ValidationResourceModal.vue?vue&type=style&index=1&id=3265ac3e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3265ac3e",
  null
  
)

export default component.exports